import { Component, Input, OnInit } from '@angular/core';
import { InjectConfig, PaConfigKey } from '@ddt-web/config-layer';
import { PartnerPlatformControlsList, SharedApplicationConstants } from '@ddt-web/domain';
import { ApplicationStateStoreProxyService, PartnerPlatform } from '@ddt-web/shared-stores';
import { take } from 'rxjs/operators';

import { PartnerPortfoliosDataService } from '../../services/partner-portfolios-data.service';

@Component({
	selector: 'ipp-partner-selection',
	templateUrl: './partner-selection.component.html',
	styleUrls: ['./partner-selection.component.scss']
})
export class PartnerSelectionComponent implements OnInit {
	@InjectConfig(PaConfigKey.PARTNER_PLATFORM_CONTROLS_LIST) public readonly partnerPlatformControlsList: PartnerPlatformControlsList;

	@Input() private mode: string = '';

	public partnerList: PartnerPlatform[] = [];
	public isPartnerListLoading: boolean = false;
	public logoLoaded: { [id: string]: boolean } = {};

	constructor(
		private applicationStateStoreProxyService: ApplicationStateStoreProxyService,
		private partnerPortfoliosDataService: PartnerPortfoliosDataService
	) { }

	public ngOnInit(): void {
		this.isPartnerListLoading = true;
		const isCompareMode = this.mode === SharedApplicationConstants.DIALOG_TABLE_MODE.COMPARE;
		this.partnerPortfoliosDataService.retrieveAndFilterPartnerList(isCompareMode)
			.pipe(take(1))
			.subscribe((partnerListConfig) => {
				this.partnerList = partnerListConfig;
				this.isPartnerListLoading = false;
				this.partnerList.forEach(partner => this.logoLoaded[partner.id] = false);
			});
	}

	public togglePartnerSelection(selectedPartnerId: string): void {
		let selectedPartner;
		this.partnerList = this.partnerList?.map((partner) => {
			const isSelected = selectedPartnerId === partner.id;
			const updatedPartner = { ...partner, isSelected: isSelected };
			if (isSelected) {
				selectedPartner = updatedPartner;
			}
			return updatedPartner;
		});

		this.applicationStateStoreProxyService.updateImportPartnerPortfoliosPartnerPlatform(selectedPartner);
	}
}
